const translations = {
  en: {
    title: 'Title',
    fileSize: 'Size',
    description: 'Description',
    uploader: 'Uploader',
    createDate: 'Created',
    changeDate: 'Last modified',
    previewFile: 'Preview file',
    selectForSend: 'Select for sending',
  },
};

export default function getMessage(locale, key, params) {
  const translationExists = translations[locale] && translations[locale][key];
  const translation = translationExists ? translations[locale][key] : translations['en'][key];
  if (!params) {
    return translation;
  }

  const re = /{\w+}/g;
  function replace(match) {
    const replacement = match.slice(1, -1);
    return params[replacement] ? params[replacement] : '';
  }

  return translation.replace(re, replace);
}
